import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CHURCH_CONFIG } from '../config';
import fullLogo from '../assets/agcc-full-logo.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  const mainLinks = CHURCH_CONFIG.navLinks.slice(0, -1);
  const ctaLink = CHURCH_CONFIG.navLinks[CHURCH_CONFIG.navLinks.length - 1];

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-earth-800/95 backdrop-blur-sm shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center shrink-0">
          <img src={fullLogo} alt={CHURCH_CONFIG.name} className="h-10 w-auto object-contain" />
        </Link>

        {/* Desktop Nav (centered) */}
        <nav className="hidden md:flex flex-1 items-center justify-center gap-8">
          {mainLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm tracking-widest uppercase font-body transition-colors duration-200 ${
                location.pathname === link.path
                  ? 'text-gold-400 border-b border-gold-400 pb-0.5'
                  : 'text-cream-100 hover:text-gold-400'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTA */}
        <Link
          to={ctaLink.path}
          className="hidden md:inline-block shrink-0 bg-gold-500 hover:bg-gold-400 text-earth-900 font-semibold px-5 py-2 rounded-sm tracking-widest uppercase text-xs transition-colors duration-200"
        >
          {ctaLink.label}
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-cream-100 flex flex-col gap-1.5 p-1"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-current transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          menuOpen ? 'max-h-96 py-4' : 'max-h-0'
        }`}
        style={{ background: 'rgba(10, 30, 61, 0.97)', backdropFilter: 'blur(16px)', borderTop: '1px solid rgba(192,152,112,0.12)', boxShadow: '0 8px 32px rgba(0,0,0,0.4)' }}
      >
        {CHURCH_CONFIG.navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`block px-6 py-3.5 text-sm tracking-widest uppercase transition-colors border-b border-white/5 last:border-0 ${
              location.pathname === link.path ? 'text-gold-400' : 'text-cream-100 hover:text-gold-400'
            }`}
          >
            {link.label}
          </Link>
        ))}
      </div>
    </header>
  );
}
